import { updateCalendarSidePanelState } from './updateCalendarSidePanelState';
import { CalendarLayoutLeftPaneConstants } from '../constants';
import getLeftPaneMinWidth from '../selectors/getLeftPaneMinWidth';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getIsLeftNavShown } from '../selectors/getIsLeftNavShown';

/**
 * Set the folder pane width
 * @param width the width of left pane width
 */
export default function setCalendarLeftPaneWidth(width: number) {
    const viewStateConfiguration = getUserConfiguration().ViewStateConfiguration;

    if (width == viewStateConfiguration.CalendarSidePanelWidth) {
        // No-op when new width is the same as the saved width in userOptions
        return null;
    }

    let shouldExpandFolderPane: boolean;
    let newNavigationBarWidth: number;

    if (width < getLeftPaneMinWidth() && getIsLeftNavShown()) {
        // Set the width to minimum and collapse the pane
        shouldExpandFolderPane = false;
        newNavigationBarWidth = CalendarLayoutLeftPaneConstants.leftPaneDefaultWidth;
    } else {
        // Left pane should be expanded
        // Make sure the width doesn't exceed the max threshold
        // Or User drags the folder pane when it's collapsed, we should expand the folder pane
        shouldExpandFolderPane = true;
        newNavigationBarWidth = Math.min(width, CalendarLayoutLeftPaneConstants.leftPaneMaxWidth);
    }

    return updateCalendarSidePanelState(shouldExpandFolderPane, newNavigationBarWidth);
}
